// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wp_a bii_b"};